import { NotifyHelper } from "../../../helpers/toast";
import { eToChucThiActionsObj } from "../../action-types/category/IToChucThiActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const toChucThiActions = {
  ...generateActions(eToChucThiActionsObj, "TO_CHUC_THI"),
  ...generateActionForKey(
    eToChucThiActionsObj,
    "TO_CHUC_THI",
    "LOAD_DOT_THI_ERRR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eToChucThiActionsObj,
    "TO_CHUC_THI",
    "LOAD_ERRR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
};
